import mainLogo from "src/assets/images/main-logo.png";
import { config } from "src/utils";
import { IStudentInvoice } from "src/services/feesDetails/fees.model";

interface ReceiptLogoProps {
  invoiceData?: IStudentInvoice | null;
}

export const ReceiptLogo = ({ invoiceData }: ReceiptLogoProps) => {
  const branchLogo = invoiceData?.branch?.logo_two || invoiceData?.branch?.logo;
  const isAbsoluteLogoUrl = branchLogo && /^https?:\/\//i.test(branchLogo);
  let logo = mainLogo;
  if (branchLogo) {
    logo = isAbsoluteLogoUrl
      ? branchLogo
      : `${config.bucket_name}/${branchLogo}`;
  }

  return (
    <tr className={"receipt-width-40 gx-text-left"}>
      <td>
        <img
          className={"img-thumbnail receipt-logo-width receipt-logo-height"}
          crossOrigin="anonymous"

          src={logo}
          alt="upload"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = mainLogo;
          }}
        />
        {invoiceData?.branch?.cin ? (
          <div className={"receipt-small-top-spacing"}>
            <b>CIN</b> : {invoiceData.branch.cin}
          </div>
        ) : null}
        {invoiceData?.branch?.mobile_two ? (
          <div className={"receipt-small-top-spacing"}>
            <b>Mobile No</b> : {invoiceData.branch.mobile_two}
          </div>
        ) : null}
      </td>
    </tr>
  );
};
